import { useEffect } from 'react';
import { useLoader } from 'src/provider/LoaderProvider';

/**
 * Shows the global page loader while any of the given fetches are in flight.
 */
export const useAnalyticsLoader = (...isFetchingFlags: boolean[]) => {
  const loader = useLoader();
  const isLoading = isFetchingFlags.some(Boolean);

  useEffect(() => {
    isLoading ? loader.show() : loader.hide();
  }, [isLoading]);
};
